import { environment } from './../../../../environments/environment';
import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { httpParams } from '../../../core/_utils';

const FAQ_API_URL = `${environment.apiPrefix}/faq`;

@Injectable({
  providedIn: 'root',
})
export class FaqService implements OnDestroy {
  constructor(private http: HttpClient) {}

  ngOnDestroy() {}

  getList(page: number = null, pageSize: number = null): Observable<{ faq: any[]; metadata: any }> {
    const params = {};

    // tslint:disable no-string-literal
    if (page) {
      params['offset'] = (page - 1) * pageSize;
    }

    if (pageSize) {
      params['limit'] = pageSize;
    }
    // tslint:enable no-string-literal

    return this.http.get<{ faq: any[]; metadata: any }>(FAQ_API_URL, {
      params: httpParams(params),
    });
  }

  getById(id: number): Observable<any> {
    return this.http.get<any>(`${FAQ_API_URL}/${id}`);
  }

  addQuestion(data: any): Observable<any> {
    return this.http.post<any>(FAQ_API_URL, data);
  }

  editQuestion(id: number, data: any): Observable<any> {
    return this.http.put<any>(`${FAQ_API_URL}/${id}`, data);
  }

  deleteQuestion(id: number): Observable<boolean> {
    return this.http.delete<any>(`${FAQ_API_URL}/${id}`);
  }

  deleteMany(ids: number[]): Observable<boolean> {
    if (ids.length) {
      return this.http.delete<boolean>(FAQ_API_URL, { params: httpParams({ ids }) });
    }

    return of(true);
  }
}
